import {
  createContext,
  useContext,
  useMemo,
  useState,
  type PropsWithChildren,
} from 'react'

type ExpressCheckoutAvailabilityContextValue = {
  isWalletUnavailable: boolean
  markWalletUnavailable: () => void
}

const ExpressCheckoutAvailabilityContext =
  createContext<ExpressCheckoutAvailabilityContextValue | null>(null)
ExpressCheckoutAvailabilityContext.displayName =
  'ExpressCheckoutAvailabilityContext'

export function ExpressCheckoutAvailabilityProvider({
  children,
}: PropsWithChildren) {
  const [isWalletUnavailable, setIsWalletUnavailable] = useState(false)

  const value = useMemo<ExpressCheckoutAvailabilityContextValue>(
    () => ({
      isWalletUnavailable,
      markWalletUnavailable: () => setIsWalletUnavailable(true),
    }),
    [isWalletUnavailable]
  )

  return (
    <ExpressCheckoutAvailabilityContext.Provider value={value}>
      {children}
    </ExpressCheckoutAvailabilityContext.Provider>
  )
}

export function useExpressCheckoutAvailability(): ExpressCheckoutAvailabilityContextValue {
  const context = useContext(ExpressCheckoutAvailabilityContext)
  if (!context) {
    throw new Error(
      'useExpressCheckoutAvailability must be used within an ExpressCheckoutAvailabilityProvider'
    )
  }
  return context
}
